import React, { useState } from 'react';
import Components from './components/Components';
import ScrolToTop from './components/Elements/ScrolToTop';
import Cookies from './components/Elements/Cookies';
import ChatWidget from "./components/BubbleChat/ChatWidget";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n"; 

const App = () => {

  return (
    <div className="App">
      <I18nextProvider i18n={i18n}>
        <Components />
        <ChatWidget />
        <Cookies />
        <ScrolToTop />
      </I18nextProvider>
    </div>
  );
};

export default App;